export default "__VITE_ASSET__DJETO9hn__"